import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Progress, Tooltip } from 'antd';
import classNames from 'classnames';

import { DashedCircleIcon } from 'app/components/commons/icons/DashedCircleIcon';

import { VARIANT_CONFIG, getVariantFromScore } from '../../scoreUtils';

import styles from './ScorePanel.module.scss';

type ScorePanelProps = {
  score?: number;
};

export const ScorePanel = ({ score }: ScorePanelProps) => {
  const form = Form.useFormInstance<{
    averageRoomPrice?: number | null;
    defaultNightRoomDiscount?: number | null;
    lastMinuteNightRoomDiscountRate?: number | null;
    lastMinuteNightRoomDiscountDays?: number | null;
  }>();
  const lastMinuteNightRoomDiscountRate = Form.useWatch(
    'lastMinuteNightRoomDiscountRate',
    form
  );

  const variant = getVariantFromScore(score);
  const config = VARIANT_CONFIG[variant];
  const percentage = score !== undefined ? Math.round(score) : 0;

  return (
    <div
      className={classNames(styles.panel)}
      style={{
        backgroundColor: config.backgroundColor,
        borderColor: config.borderColor,
      }}
    >
      <div className={styles.content}>
        <div className={styles.progressSection}>
          <Progress
            type="circle"
            percent={percentage}
            width={48}
            strokeColor={config.strokeColor}
            strokeWidth={10}
            strokeLinecap="square"
            trailColor="#00000014"
            format={() => (score !== undefined ? Math.round(score) : '-')}
          />
        </div>
        <div className={styles.textSection}>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{config.title}</div>
            <div className={styles.subtitle}>{config.subtitle}</div>
          </div>
          {config.items.length > 0 && (
            <div className={styles.itemsList}>
              {config.items.map((item, index) => (
                <div key={index} className={styles.item}>
                  <DashedCircleIcon />
                  <span>{item}</span>
                </div>
              ))}
              {variant !== 'default' && variant !== 'green' && (
                <div className={styles.item}>
                  <DashedCircleIcon />
                  <span>
                    {lastMinuteNightRoomDiscountRate
                      ? 'Increase Last Minute Discount'
                      : 'Turn on Last Minute Discount'}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        <Tooltip
          title="Based on the current sales range for the next 8 weeks"
          placement="left"
        >
          <InfoCircleOutlined className={styles.infoIcon} />
        </Tooltip>
      </div>
    </div>
  );
};
